export const faqs = [
  {
    id: 1,
    question: "What is Cell Clinic Hyderabad?",
    answer:
      "Cell Clinic Hyderabad is the best mobile repair platform. Customers can find information about mobile phone repair services, book appointments, and get their mobile phone fixed by a professional technician. We provide customers with access to certified technicians and offer competitive prices, making it a cost-effective solution for mobile phone repair.",
  },
  {
    id: 2,
    question:
      "How do I book an appointment for mobile phone repair services online?",
    answer:
      "Booking is simple. Click on the 'Book Now' button on our homepage, select your device model and issue, choose a convenient time slot, and confirm your address. Our technician will arrive at your doorstep at the scheduled time.",
  },
  {
    id: 3,
    question:
      "What are the common mobile phone issues that can be fixed by a mobile phone repair service?",
    answer:
      "We fix a wide range of issues including cracked screens, battery drainage, charging port failure, water damage, software glitches, camera issues, and speaker/microphone problems for all major brands.",
  },
  {
    id: 4,
    question: "How long does it take to repair a mobile phone?",
    answer:
      "Most repairs, such as screen or battery replacements, are completed within 30 to 60 minutes at your doorstep. Complex motherboard issues may require pickup and can take 24-48 hours.",
  },
  {
    id: 5,
    question: "What is the cost of mobile phone repair services?",
    answer:
      "The cost varies depending on the device model and the specific issue. You can get an instant quote on our website by selecting your device and problem. Our pricing is transparent with no hidden charges.",
  },
  {
    id: 6,
    question: "Can I get my mobile phone repaired on the same day?",
    answer:
      "Yes! We specialize in same-day doorstep repairs. If you book an appointment before 4 PM, we can typically fix your device on the same day, depending on technician availability.",
  },
  {
    id: 7,
    question: "How do I get my mobile repair service near me?",
    answer:
      "We serve the entire Hyderabad region. Simply book online, and our 'service on wheels' will come to your location, whether it's your home, office, or a coffee shop.",
  },
];
